import React, { Component } from 'react';

const TagsInput = props => {
    const [tags, setTags] = React.useState(props.tags);
    const inputRef = React.useRef(null)
    const onKeyDownEvent = (event) =>{
        if(event.keyCode === 13)
            addTags(event);
        else if(event.keyCode === 8 && event.target.value==="" || event.target.value== null)
            removeLastTag()
    }
    const removeTags = indexToRemove => {
        let newTags = [...tags.filter((_, index) => index !== indexToRemove)];
        setTags(newTags);
        props.selectedTags([...newTags],props.type);
    };
    const removeLastTag = () =>{
        let newTags = [...tags];
        newTags = newTags.slice(0,-1);
        setTags(newTags);
        props.selectedTags([...newTags],props.type);
    }
    const addTags = event => {
        if (event.target.value !== "") {
            setTags([...tags, event.target.value]);
            props.selectedTags([...tags, event.target.value],props.type);
            event.target.value = "";
        }
    };
    return (
        <div className="tags-input" onClick={()=>{console.log("çalıştı");inputRef.current.focus()}}>
            <ul id="tags">
                {tags.map((tag, index) => (
                    <li key={index} className="single-tag">
                        <span className='tag-title'>{tag}</span>
                        <span className='tag-close-icon'
                              onClick={() => removeTags(index)}
                        >
							x
						</span>
                    </li>
                ))}
            </ul>
            <input ref={inputRef}
                type="text"
                id="tags-input"
                onKeyDown={event => onKeyDownEvent(event)}
            />
        </div>
    );
};

export default TagsInput;
